<template>
  <div>
    <div v-if="!friends || friends.length === 0" class="text-center pa-8 white--text">
      <v-icon color="white" size="60" class="mb-3">mdi-account-off-outline</v-icon>
      <p>Noch keine Freunde gefunden.</p>
    </div>

    <v-list dark v-else color="transparent">
      <v-list-item v-for="friend in friends" :key="friend._id" @click="$emit('view-profile', friend._id)">
        <v-list-item-avatar>
          <v-img :src="friend.bild ? '/img/profilbilder/' + friend.bild : '/img/profilbilder/uploads/1741100494649.png'"></v-img>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title
            >{{ friend.vorname }} {{ friend.nachname }}
            <v-icon v-if="friend.isTrainingPartner" small color="primary" class="ml-2" title="Trainingspartner"
              >mdi-dumbbell</v-icon
            ></v-list-item-title
          >

          <v-list-item-subtitle v-if="friend.username">@{{ friend.username }}</v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-action>
          <v-icon>mdi-chevron-right</v-icon>
        </v-list-item-action>
      </v-list-item>
    </v-list>
  </div>
</template>

<script>
export default {
  name: "FriendListComponent",
  props: {
    friends: {
      type: Array,
      required: true,
    },
  },
}
</script>
